
import { createAction } from 'redux-actions'
import { navigate } from '@segment/deku-enroute'
import { error } from '@segment/notify'
import superagent from 'superagent'
import fetch from 'lib/fetch'

/**
 * Audiences list.
 */

export const AUDIENCES_LIST_REQUESTING = 'AUDIENCES_LIST_REQUESTING'
export const AUDIENCES_LIST_REQUEST_ERROR = 'AUDIENCES_LIST_REQUEST_ERROR'
export const AUDIENCES_LIST_RECEIVED = 'AUDIENCES_LIST_RECEIVED'

export const audiencesListRequesting = createAction(AUDIENCES_LIST_REQUESTING)
export const audiencesListRequestError = createAction(AUDIENCES_LIST_REQUEST_ERROR)
export const audiencesListReceived = createAction(AUDIENCES_LIST_RECEIVED)

export const listAudiences = params => dispatch => {
  const { workspaceSlug } = params
  dispatch(audiencesListRequesting({ workspaceSlug }))
  superagent
    .get(`/api/workspaces/${workspaceSlug}/audiences`)
    .end((err, res) => {
      if (err || !res.ok) {
        const error = err || new Error('Unable to fetch audiences')
        dispatch(audiencesListRequestError({ workspaceSlug, error }))
      } else if (res.error) {
        dispatch(audiencesListRequestError({ workspaceSlug, error: res.error }))
      } else {
        dispatch(audiencesListReceived({ workspaceSlug, data: res.body }))
      }
    })
}

/**
 * Audiences filter.
 */

export const AUDIENCES_ENTER_FILTER = 'AUDIENCES_ENTER_FILTER'

export const filterAudiences = createAction(AUDIENCES_ENTER_FILTER)

/**
 * Audiences setup.
 */

export const AUDIENCES_SETUP_BEGIN = 'AUDIENCES_SETUP_BEGIN'
export const AUDIENCES_SETUP_UPDATE = 'AUDIENCES_SETUP_UPDATE'

export const audienceSetupBegin = createAction(AUDIENCES_SETUP_BEGIN)
export const audienceSetupUpdate = createAction(AUDIENCES_SETUP_UPDATE)

/**
 * Audience get.
 */

export const AUDIENCES_GET_REQUESTING = 'AUDIENCES_GET_REQUESTING'
export const AUDIENCES_GET_REQUEST_ERROR = 'AUDIENCES_GET_REQUEST_ERROR'
export const AUDIENCES_GET_RECEIVED = 'AUDIENCES_GET_RECEIVED'

export const audiencesGetRequesting = createAction(AUDIENCES_GET_REQUESTING)
export const audiencesGetRequestError = createAction(AUDIENCES_GET_REQUEST_ERROR)
export const audiencesGetReceived = createAction(AUDIENCES_GET_RECEIVED)

export const getAudience = params => dispatch => {
  const { workspaceSlug, audienceId } = params
  dispatch(audiencesGetRequesting({ workspaceSlug, audienceId }))
  superagent
    .get(`/api/workspaces/${workspaceSlug}/audiences/${audienceId}`)
    .end((err, res) => {
      if (err || !res.ok) {
        const error = err || new Error('Unable to fetch audience')
        dispatch(audiencesGetRequestError({ workspaceSlug, audienceId, error }))
      } else if (res.error) {
        dispatch(audiencesGetRequestError({ workspaceSlug, audienceId, error: res.error }))
      } else {
        dispatch(audiencesGetReceived({ workspaceSlug, audienceId, data: res.body }))
      }
    })
}

/**
 * Audience creation.
 * (supports both audience and computed-trait via the type attr)
 */

export const AUDIENCES_CREATE_REQUESTING = 'AUDIENCES_CREATE_REQUESTING'
export const AUDIENCES_CREATE_REQUEST_ERROR = 'AUDIENCES_CREATE_REQUEST_ERROR'
export const AUDIENCES_CREATE_RECEIVED = 'AUDIENCES_CREATE_RECEIVED'

export const audiencesCreateRequesting = createAction(AUDIENCES_CREATE_REQUESTING)
export const audiencesCreateRequestError = createAction(AUDIENCES_CREATE_REQUEST_ERROR)
export const audiencesCreateReceived = createAction(AUDIENCES_CREATE_RECEIVED)

export const createAudience = params => dispatch => {
  const { workspaceSlug, attrs, redirect } = params
  dispatch(audiencesCreateRequesting({ workspaceSlug }))

  fetch(`/api/workspaces/${workspaceSlug}/audiences`, {
    method: 'POST',
    body: JSON.stringify(attrs)
  })
  .then(res => {
    if (res.status === 403) {
      error('This slug collides with another you already have. Please choose another name.')
    }

    if (!res.ok) {
      throw new Error('Unable to create audience')
    }

    return res.json()
  })
  .then(data => {
    dispatch(audiencesCreateReceived({ workspaceSlug, data }))
    if (redirect) navigate(redirect)
  })
  .catch(error => {
    dispatch(audiencesCreateRequestError({ workspaceSlug, error }))
  })
}

/**
 * Audience removal.
 */

export const AUDIENCES_DELETE_REQUESTING = 'AUDIENCES_DELETE_REQUESTING'
export const AUDIENCES_DELETE_REQUEST_ERROR = 'AUDIENCES_DELETE_REQUEST_ERROR'
export const AUDIENCES_DELETE_RECEIVED = 'AUDIENCES_DELETE_RECEIVED'

export const audiencesDeleteRequesting = createAction(AUDIENCES_DELETE_REQUESTING)
export const audiencesDeleteRequestError = createAction(AUDIENCES_DELETE_REQUEST_ERROR)
export const audiencesDeleteReceived = createAction(AUDIENCES_DELETE_RECEIVED)

export const deleteAudience = params => dispatch => {
  const { workspaceSlug, audienceId, redirect } = params
  dispatch(audiencesDeleteRequesting({ workspaceSlug, audienceId }))

  fetch(`/api/workspaces/${workspaceSlug}/audiences/${audienceId}`, {
    method: 'DELETE'
  })
  .then(res => {
    if (!res.ok) {
      throw new Error('Unable to delete audience')
    }

    return res.json()
  })
  .then(data => {
    dispatch(audiencesDeleteReceived({ workspaceSlug, audienceId, data }))
    if (redirect) navigate(redirect)
  })
  .catch(error => {
    dispatch(audiencesDeleteRequestError({ workspaceSlug, audienceId, error }))
  })
}



// WEBPACK FOOTER //
// ./actions/audiences.js